import { useEffect, useRef } from "react";
import {
  formatDateTimeToReadableIndo,
} from "utils/dateHelpers";

const { useStockHistory } = require("../StockHistoryContext");

const DetailHistory = ({ initialData }) => {
  const {
    stockHistories,
    isLoading,
    handleFilterByMenu,
    Pagination,
  } = useStockHistory();

  // handleFilterByMenu
  // useEffect(() => {
  //   if (initialData) {
  //     handleFilterByMenu(initialData.id);
  //   }
  // }, [initialData, handleFilterByMenu]);

  const prevMenuIdRef = useRef(null);

  useEffect(() => {
    if (
      initialData?.id &&
      prevMenuIdRef.current !== initialData.id
    ) {
      handleFilterByMenu(initialData.id);
      prevMenuIdRef.current = initialData.id;
    }
  }, [initialData?.id]); // hanya depend ke ID string, bukan objek/fungsi

  return (
    <div>
      <h5>Riwayat Stok</h5>
      {/* print json stockHistory */}
      {/* <pre>{JSON.stringify(stockHistories, null, 2)}</pre> */}
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>No</th>
              <th>created_by</th>
              <th>stock</th>
              <th>supplier</th>
              <th>Description</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {stockHistories?.map((item, i) => (
              <tr key={item.id}>
                <td>{i + 1}</td>
                <td>{item.created_by?.name}</td>
                <td>{item.stock}</td>
                <td>{item.supplier?.name || "-"}</td>
                <td>{item.note}</td>
                <td>{formatDateTimeToReadableIndo(item.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div className="mt-4 text-center">{Pagination}</div>
    </div>
  );
};

export default DetailHistory;
